import { biLoggerFactory } from 'wix-private';
import wixLocation from 'wix-location';
import storage from 'public/storage';

const msid = '45ff9c0a-9249-4c58-b07c-2fd2191ce9d4';
// const msid = 'd089ed31-14fc-4c40-8fe2-781f2c35415b';

const genericLogger = biLoggerFactory('generic', 2, {msid});

export function templatesAction({flow = null, action, templateId, hoverMs = undefined, screenHeight, screenWidth}) {
	return genericLogger.log({
		evid: 804,
		screen_name: 'expressions',
		template_id: templateId,
		hover_ms: hoverMs,
		action,
		flow,
		screen_height: screenHeight,
		screen_width: screenWidth,
		origin: 'expressions',
		_brandId: getBrandId(),
		esi: storage.getSessionId(),
	})
}

function getBrandId() {
	return 'editorx';
	// return wixLocation.baseUrl.includes('wix.com') ? 'wix' : 'editorx';
}